import React from 'react';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import RequiredIcon from '../../RequiredIcon';

import { getLabelStyles } from './Label.styles';

const Label = ({ children, required = false, error = false, withRequiredIcon = true }) => (
  <Typography
    data-truncated
    className={clsx('label', { 'Mui-error': error })}
    component="label"
    required={required}
    sx={getLabelStyles(error)}
    variant="regular14"
  >
    {children}
    {required && withRequiredIcon && <RequiredIcon />}
  </Typography>
);

Label.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
  withRequiredIcon: PropTypes.bool,
};

export default Label;
